var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-container",staticStyle:{"padding-bottom":"80%"},attrs:{"id":"container"}},[_c('svg',{attrs:{"id":'verticalbargoals' + _vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }